<template>
  <div class="container-fluid" id="assumptions">
    <div class="row wrapper">
      <div class="col-12 col-md-4 side-banner">
        <div class="header">
          <div id="steps" class="steps" tabindex="0" role="document">
            &nbsp;
          </div>
          <div class="company-logo"></div>
          <h2>Disclaimer</h2>
          <div class="hero-image" alt="Edit assumptions"></div>
        </div>
      </div>
      <div class="col-12 col-md-8 main-banner">
        <div class="main assumptions-field">

          <div class="disclaimer-content disclaimer-text" v-html="pageContent.pages.disclaimerCopy">

          </div>
          <div class="ver text-end pe-2 py-1">
            <small>v{{ appVersion }}r{{ this.revision }}</small>
          </div>

          <div class="nav-button row">
            <a class="back-button col-auto" @click="$router.go(-1)" tabindex="0" role="button">Back</a>
          </div>

        </div>
      </div>

    </div>
    <footer>
      <span class="assumption-button">&nbsp;</span>
    </footer>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from 'vuex';

export default {
  name: 'Assumptions',
  components: {},
	computed: {
    ...mapFields([
      "wageInflation", "priceInflation", "investmentReturn", "retirementAge", "superGuarantee",
      "paymentPeriod", "tpdRepayDebtsLiabilities","tpdFutureIncomeLevel", "tpdCeaseAllowanceForFutureIncomeAtAge",
      "incomeProtectionPaymentPeriod", "incomeProtectionPercentage", "incomeProtectionSuperGuarantee",
      "lifeInsurancePaymentPeriod", "lifeInsuranceInvestmentReturn", "appVersion", "revision"
    ]),
    ...mapGetters(["pageContent"]),
  },
  mounted() {
    this.$refreshIframeHeight();
    this.$scrollIframeTop();
    window.addEventListener("resize", this.$refreshIframeHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.$refreshIframeHeight);
  }
}

</script>
